import React, { Fragment,Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/layout/Navbar';
import Search from './components/layout/Search';
import LinkResults from './components/layout/LinkResults';
import Alert from './components/layout/Alert';
import About from './components/pages/About';
import ResultDetails from './components/pages/ResultDetails';
import Images from './components/pages/Images';
import Words from './components/pages/Words';
import axios from 'axios';

class App extends Component {

    state = {
      loading: false,
      alert: null,
      data_holder: [],
      links_holder: [],
      base_url: '',
      currentColor: '',
      validURL: '',
      redCount: 0,
      greenCount: 0,
      totalCount: 0
    }

  searchUrl = async text => {

    this.setState({links_holder: []});
    this.setState({data_holder: []});
    this.setState({loading: true});
    this.finalCall(text);
    this.setState({loading: false});
    
  }

  setAlert = (msg, type) => {
    this.setState({ alert: {msg: msg, type: type} });

    setTimeout(() => this.setState({ alert: null }), 5000)
  }

  finalCall = async (text) => {
    await this.processLinks(text);
  }

  processLinks = async (text) => {
    await this.extractData(text);

    const promises = this.state.links_holder.map(async (results, index) => {
      await this.connectionCheck(results.url);
    });
    return Promise.all(promises);
  }

  extractData = async (text) => {
    //console.log(this.state.text);
    await axios.get(text).then(res => {
      this.setState({base_url: this.exrtactBaseURL(text)});
      this.extract_href_doubleQuote(res.data, this.state.base_url);
      this.extract_href_singleQuote(res.data, this.state.base_url);
      this.extract_src_images_doubleQuote(res.data, this.state.base_url);
      this.extract_src_images_singleQuote(res.data, this.state.base_url);
      this.extract_bckGrnd_images(res.data, this.state.base_url);
      this.extract_content(res.data, this.state.base_url);

      return this.state.links_holder;
    })

  }

  connectionCheck = async (searchURL) => {
    let config ={
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Host":"https://linkcheck.mytestingtools.com",
        "User-Agent":"PostmanRuntime/7.24.1",
        "Accept":"*/*",
        "Accept-Encoding":"gzip, deflate, br",
        "Connection":"keep-alive"
      }

    }
    await axios.get(searchURL, config).then((response) => {
      this.setState({totalCount: this.state.totalCount+1});
      if(response.status === 200){
        this.setState({data_holder: this.state.data_holder.concat({url:searchURL,color: 'green'})});
        this.setState({greenCount:  this.state.greenCount+1});
        return;
      }
    }).catch(error => {
      this.setState({data_holder: this.state.data_holder.concat({url:searchURL,color: 'red'})});
      this.setState({redCount:  this.state.redCount+1});
    });
  }
  
  exrtactBaseURL = (search_url) => {
    //extract base URL
    var pathArray = search_url.split( '/' );
    var protocol = pathArray[0];
    var host = pathArray[2];
    this.base_url = protocol.toString().toLowerCase() + '//' + host.toString().toLowerCase();
  }

  extract_href_doubleQuote = (dataz, base_url) => {
    const href_loc = dataz.indexOf("href=\"");

    if(href_loc>0){
      var existing_url = dataz.substring(href_loc+6,dataz.indexOf('"', href_loc+6)).trim();

      if(existing_url.match(/^((http|https|ftp):\/\/)/)){
        this.setState({links_holder: this.state.links_holder.concat({url:existing_url,color: ''})});
      }else if(existing_url.match(/^\/\/\w+/)){
        if(existing_url.match(/^\/\/www.\w+/)){
          this.setState({links_holder: this.state.links_holder.concat({url:"http:" + existing_url,color: ''})});
        }else if(existing_url.match(/^\/\/.+\.(com|net|org|nyc|edu)\w*/)){
          this.setState({links_holder: this.state.links_holder.concat({url:"http:" + existing_url,color: ''})});
        }else{
          this.setState({links_holder: this.state.links_holder.concat({url:existing_url,color: ''})});
        }
      }else if(existing_url.match(/^\/\w+/)){
        if(existing_url.match(/^\/\/www.\w+/)){
          this.setState({links_holder: this.state.links_holder.concat({url:"http:" + existing_url,color: ''})});
        }else{
          this.setState({links_holder: this.state.links_holder.concat({url:this.base_url + existing_url,color: ''})});
        }
      }else if(existing_url.match(/^javascript:\w*/)){
        this.setState({links_holder: this.state.links_holder.concat({url:existing_url,color: ''})});
      }else if(existing_url.match(/^(?!.*http)/)){
        this.setState({links_holder: this.state.links_holder.concat({url:this.base_url + "/" + existing_url,color: ''})});
      }else{
        this.setState({links_holder: this.state.links_holder.concat({url:this.base_url + existing_url,color: ''})});
      }

      this.extract_href_doubleQuote(dataz.substring(dataz.indexOf('"', href_loc+6)),this.base_url);
    }
    else{
      return null;
    }
  }

  extract_href_singleQuote = (dataz,base_url) => {
    const href_loc2 = dataz.indexOf("href='");
    if(href_loc2>0){
      var existing_url = dataz.substring(href_loc2+6,dataz.indexOf('\'', href_loc2+6)).trim();
      if(existing_url.match(/^((http|https|ftp):\/\/)/)){
        this.setState({links_holder: this.state.links_holder.concat({url:existing_url,color: ''})});
      }else if(existing_url.match(/^\/\/\w+/)){
        if(existing_url.match(/^\/\/www.\w+/)){
          this.setState({links_holder: this.state.links_holder.concat({url:"http:" + existing_url,color: ''})});
        }else if(existing_url.match(/^\/\/.+\.(com|net|org|nyc|edu)\w*/)){
          this.setState({links_holder: this.state.links_holder.concat({url:"http:" + existing_url,color: ''})});
        }else{
          this.setState({links_holder: this.state.links_holder.concat({url:existing_url,color: ''})});
        }
      }else if(existing_url.match(/^\/\w+/)){
        if(existing_url.match(/^\/\/www.\w+/)){
          this.setState({links_holder: this.state.links_holder.concat({url:"http:" + existing_url,color: ''})});
        }else{
          this.setState({links_holder: this.state.links_holder.concat({url:this.base_url + existing_url,color: ''})});
        }
      }else if(existing_url.match(/^javascript:\w*/)){
        this.setState({links_holder: this.state.links_holder.concat({url:existing_url,color: ''})});
      }else if(existing_url.match(/^(?!.*http)/)){
        this.setState({links_holder: this.state.links_holder.concat({url:this.base_url + "/" + existing_url,color: ''})});
      }else{
        this.setState({links_holder: this.state.links_holder.concat({url:this.base_url + existing_url,color: ''})});
      }

      this.extract_href_singleQuote(dataz.substring(dataz.indexOf('\'', href_loc2+6)),this.base_url);
    }
    else{
      return null;
    }
  }

  extract_src_images_doubleQuote = (dataz, base_url) => {
    const href_loc = dataz.indexOf("src=\"");
    if(href_loc>0){
      var existing_url = dataz.substring(href_loc+5,dataz.indexOf('"', href_loc+5)).trim();

      if(existing_url.match(/(jpg|bmp|jpeg|png)$/)){
        if(existing_url.match(/^((http|https|ftp):\/\/)/)){
          this.setState({links_holder: this.state.links_holder.concat({url:existing_url,color: ''})});
        }else if(existing_url.match(/^\/\/\w+/)){
          this.setState({links_holder: this.state.links_holder.concat({url:existing_url,color: ''})});
        }else if(existing_url.match(/^\/\w+/)){
          this.setState({links_holder: this.state.links_holder.concat({url:this.base_url + existing_url,color: ''})});
        }else if(existing_url.match(/^javascript:\w+/)){
          this.setState({links_holder: this.state.links_holder.concat({url:existing_url,color: ''})});
        }else if(existing_url.match(/^(?!.*http)/)){
          this.setState({links_holder: this.state.links_holder.concat({url:this.base_url + "/" + existing_url,color: ''})});
        }else{
          this.setState({links_holder: this.state.links_holder.concat({url:this.base_url + existing_url,color: ''})});
        }
      }

      this.extract_src_images_doubleQuote(dataz.substring(dataz.indexOf('"', href_loc+5)),this.base_url);
    }
    else{
      return null;
    }
  }

  extract_src_images_singleQuote = (dataz, base_url) => {
    const href_loc = dataz.indexOf("src='");
    if(href_loc>0){
      var existing_url = dataz.substring(href_loc+5,dataz.indexOf('\'', href_loc+5)).trim();

      if(existing_url.match(/(jpg|bmp|jpeg|png)$/)){
        if(existing_url.match(/^((http|https|ftp):\/\/)/)){
          this.setState({links_holder: this.state.links_holder.concat({url:existing_url,color: ''})});
        }else if(existing_url.match(/^\/\/\w+/)){
          this.setState({links_holder: this.state.links_holder.concat({url:existing_url,color: ''})});
        }else if(existing_url.match(/^\/\w+/)){
          this.setState({links_holder: this.state.links_holder.concat({url:this.base_url + existing_url,color: ''})});
        }else if(existing_url.match(/^javascript:\w+/)){
          this.setState({links_holder: this.state.links_holder.concat({url:existing_url,color: ''})});
        }else if(existing_url.match(/^(?!.*http)/)){
          this.setState({links_holder: this.state.links_holder.concat({url:this.base_url + "/" + existing_url,color: ''})});
        }else{
          this.setState({links_holder: this.state.links_holder.concat({url:this.base_url + existing_url,color: ''})});
        }
      }

      this.extract_src_images_singleQuote(dataz.substring(dataz.indexOf('\'', href_loc+5)),this.base_url);
    }
    else{
      return null;
    }
  }


  extract_bckGrnd_images = (dataz, base_url) => {
    const href_loc = dataz.indexOf("background-image:url(");
    if(href_loc>0){
      var existing_url = dataz.substring(href_loc+21,dataz.indexOf(')', href_loc+21)).trim();
      existing_url = existing_url.replace(/^\s+|\s+$/g, "");
      if(existing_url.match(/(jpg|bmp|jpeg|png)$/)){
        if(existing_url.match(/^((http|https|ftp):\/\/)/)){
          this.setState({links_holder: this.state.links_holder.concat({url:existing_url,color: ''})});
        }else if(existing_url.match(/^\/\/\w+/)){
          this.setState({links_holder: this.state.links_holder.concat({url:existing_url,color: ''})});
        }else if(existing_url.match(/^\/\w+/)){
          this.setState({links_holder: this.state.links_holder.concat({url:this.base_url + existing_url,color: ''})});
        }else if(existing_url.match(/^javascript:\w+/)){
          this.setState({links_holder: this.state.links_holder.concat({url:existing_url,color: ''})});
        }else if(existing_url.match(/^(?!.*http)/)){
          this.setState({links_holder: this.state.links_holder.concat({url:this.base_url + "/" + existing_url,color: ''})});
        }else{
          this.setState({links_holder: this.state.links_holder.concat({url:this.base_url + existing_url,color: ''})});
        }
      }

      this.extract_bckGrnd_images(dataz.substring(dataz.indexOf(')', href_loc+21)),this.base_url);
    }
    else{
      return null;
    }    
  }

  extract_content = (dataz, base_url) => {
    const href_loc = dataz.indexOf("content=\"");
    if(href_loc>0){
      var existing_url = dataz.substring(href_loc+9,dataz.indexOf('"', href_loc+9)).trim();
      if(existing_url.match(/^((http|https|ftp):\/\/)/)){
        this.setState({links_holder: this.state.links_holder.concat({url:existing_url,color: ''})});
      }
      if(existing_url.match(/(jpg|bmp|jpeg|png)$/)){
        if(existing_url.match(/^((http|https|ftp):\/\/)/)){
          this.setState({links_holder: this.state.links_holder.concat({url:existing_url,color: ''})});
        }else if(existing_url.match(/^\/\/\w+/)){
          this.setState({links_holder: this.state.links_holder.concat({url:existing_url,color: ''})});
        }else if(existing_url.match(/^\/\w+/)){
          this.setState({links_holder: this.state.links_holder.concat({url:this.base_url + existing_url,color: ''})});
        }else if(existing_url.match(/^javascript:\w+/)){
          this.setState({links_holder: this.state.links_holder.concat({url:existing_url,color: ''})});
        }else if(existing_url.match(/^(?!.*http)/)){
          this.setState({links_holder: this.state.links_holder.concat({url:this.base_url + "/" + existing_url,color: ''})});
        }else{
          this.setState({links_holder: this.state.links_holder.concat({url:this.base_url + existing_url,color: ''})});
        }
      }

      this.extract_content(dataz.substring(dataz.indexOf('"', href_loc+9)),this.base_url);
    }
    else{
      return null;
    }
  }

  render() {

    return (
      <Router>
        <div className="App">
          <Navbar title='LINK CHECK' icon='fas fa-link'/>
          <Switch>
              <Route exact path="/" render={props =>(
                <Fragment>
                  <div className='container'>
                    <h3><b>GENERAL SEARCH</b></h3>
                    <Alert alert={ this.state.alert } />
                    <Search searchUrl={this.searchUrl} setAlert={ this.setAlert } />
                  </div>
                  <div className='container'>
                    <LinkResults loading={this.state.loading} data_holder={this.state.data_holder} greenCount={this.state.greenCount} redCount={this.state.redCount} totalCount={this.state.totalCount}/>
                  </div>                 
                </Fragment>
              )} />
              <Route exact path='/about' component={About} />
              <Route exact path='/resultDetails' component={ResultDetails} />
              <Route exact path='/images' component={Images} />
              <Route exact path='/words' component={Words} />
            </Switch>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js